module.exports = __webpack_public_path__ + "img/discord.a31d6104.svg";